<template>
	<div class="df1" v-loading.fullscreen.lock="loading">
		<el-form ref="form" :model="form" :rules="rules"   
		              label-position="top">
					 
			<el-form-item label="Company/Label Name" prop="name" > 
				<el-input v-model="form.name" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="E-mail" prop="eMail">
				<el-input v-model="form.eMail" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="Infringed Platform" prop="infringedPlatform">
				<el-input v-model="form.infringedPlatform" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="Please identify the nature of your copyright" prop="identify">
				<el-select v-model="form.identify" placeholder=""  filterable   :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in identifyOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				 </el-select>
			</el-form-item> 
			<div class="divForm">
				<div class="divDFrom">
					<div class="blueClass"></div>
					Song(s) in dispute
				</div>
				<el-form-item label="Song Title"  prop="complaintTrackTitle">
					<span class="labelSpan" style="left: 95px;"> When listing multiple items or elements, use commas for separation</span>
					<el-input v-model="form.complaintTrackTitle" type="textarea" 
							resize="none"    :autosize="{ minRows: 3,maxRows: 3 }" ></el-input>
				</el-form-item>
				<el-form-item label="Link for the song"  prop="complaintTrackLink">
					<span class="labelSpan" style="left: 135px;"> When listing multiple items or elements, use commas for separation</span>
					<el-input v-model="form.complaintTrackLink" type="textarea" 
							resize="none"    :autosize="{ minRows: 4,maxRows: 4 }" ></el-input>
				</el-form-item>
			</div>
			
			
			<div class="divForm" :style="{'paddingBottom': divLength}">
				<div class="divDFrom">
					<div class="blueClass"></div>
					My proof
				</div>
				
				<el-form-item label="Song Title"  prop="originalTrackTitle">
					<span class="labelSpan" style="left: 95px;"> When listing multiple items or elements, use commas for separation</span>
					<el-input v-model="form.originalTrackTitle" type="textarea" 
							resize="none"    :autosize="{ minRows: 3 ,maxRows: 3}" ></el-input>
				</el-form-item>
				<el-form-item label="Link of the proof"  prop="originalTrackLink">
					<span class="labelSpan" style="left: 95px;"> When listing multiple items or elements, use commas for separation</span>
					
				  <el-input v-model="form.originalTrackLink" type="textarea" 
							resize="none"    :autosize="{ minRows: 4 ,maxRows: 4}" ></el-input>
				</el-form-item>
				
				<div style="height: 100px;
							position: absolute;
							top: 1380px;
							font-size: 8px;">
					<el-upload
					  ref="upload"
					  class="upload-demo"
					  accept=".pdf"
					  action="https://cms.ewway.com/ewway-api/common/uploadWeb"
					  :on-remove="handleRemove"
					  :on-success="handleAvatarSuccess"
					  :on-exceed="handleExceed"
					  :on-error="handleError"
					  :before-upload="handleBefore"
					  :multiple=true
					  :limit="10"
					  >
					  <el-button size="small" type="primary">Upload</el-button>
					  <div slot="tip" class="el-upload__tip">Format: PDF; File size: Up to 20MB.</div>
					</el-upload>
				</div>
				
					
				<el-form-item label="Proof of Rights Documents"  prop="fileInfo" style="margin-bottom: 0px;">
					<el-input v-model="form.fileInfo" style="display: none;" ></el-input>
				</el-form-item>
			</div>
			
			<el-form-item label="Description"  prop="description" >
			  <el-input v-model="form.description" type="textarea" 
						resize="none"    :autosize="{ minRows: 4 }" ></el-input>
			</el-form-item>
			
			
			<el-form-item label="" >
			  <el-checkbox v-model="check1" ></el-checkbox>
			  <span class="checkBoxClass" >I state that the information provided is true, valid, complete, and lawfule.</span><br>
			  <el-checkbox v-model="check2" ></el-checkbox>
			  <span class="checkBoxClass" >I understand and agree that my contact information and/or claim may be passed to the alleged responsible party in intellectual property disputes and retained as long as required for legal purposes.</span><br>
			  <el-checkbox v-model="check3"  style="margin-right: 30px;"></el-checkbox>
			  <span class="checkBoxClass" >I understand that abuse of this process may restrict my ability to submit requests in the future.</span><br>
			</el-form-item>
			
			<div v-if="required" style="width: 100%;margin-bottom: 20px; margin-top: -18px;">
				<img style="width: 14px;float: left;" src="@/assets/images/svg/web-required.svg" />field required
			</div>
			
			
			<el-button type="primary" @click="add">Submit</el-button>
					
		</el-form>
		
	</div>
	
</template>

<script>
	
import axios from 'axios';

export default {
	name : "Form2",
	data() {
		//艺术家
		const checkFile = (rule, value, callback) => {
		  console.info(value);
		  if(this.form.fileInfo && this.form.fileInfo !=""){
			  return callback()
		  }else{
			  return callback(new Error("not empty"))
		  }
		};
		return {
			identifyOption:[
				{"label":"I own the sound recording","value":"I own the sound recording"},
				{"label":"I own the composition (e.g.arrangement, melody, lyrics)","value":"I own the composition (e.g.arrangement, melody, lyrics)"},
				{"label":"I own artwork","value":"I own artwork"},
				{"label":"others","value":"others"},
				],
			form:{
				name:"",
				fileList:[],
			},
			divLength: "120px",
			rules:{
				name: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				eMail: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				infringedPlatform: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				identify: [
				  { required: true, message: "not empty", trigger: ["blur","change"]}
				],
				complaintTrackTitle: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				complaintTrackLink: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				originalTrackTitle: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				originalTrackLink: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				fileInfo: [
				  { required: true,validator: checkFile, message: "not empty", trigger: ["blur","change"]}
				],
			},
			
			fileList:[],
			check1:false,
			check2:false,
			check3:false,
			
			loading:false,
			
			required:false,
		}
	},
	watch:{
		fileList(val){
			console.info(val);
		}
	},
	methods:{
		
	  handleBefore(file){
		  for (var i = 0; i < this.fileList.length; i++) {
		  	if(this.fileList[i].fileName == file.name){
		  		this.$message({
		  				type: 'error',
		  				message: "上传文件名字重复",
		  				customClass :'customClass',
		  				duration:3000,
		  		});
		  		return false;
		  	}
		  }
		  let temp = {
			  fileName : file.name
		  }
		  this.fileList.push(temp);
		  return true;
	  },
		//上传成功
      handleAvatarSuccess(res, file) {
		if(res.code===200){
			this.$message({
					type: 'success',
					message: "success",
					customClass :'customClass',
					duration:3000,
			}); 
			let temp = {
				fileUrl : res.fileName,
				fileName : res.originalFilename,
			}
			this.form.fileList.push(temp);
			if(this.form.fileList.length<=0){
				this.form.fileInfo = null;
			}else{
				this.form.fileInfo = JSON.stringify(this.form.fileList);
			}
			this.divLength = ( 120 + (this.form.fileList.length - 1)*29.9375 ) +"px";
			console.info(this.divLength,"=====");
		}else{
			this.$message({
					type: 'error',
					message: "error",
					customClass :'customClass',
					duration:3000,
			}); 
		    this.$refs.upload.clearFiles();
		}
        
		this.$forceUpdate();
      },
		
	  handleRemove(file, fileList) {
		if (file && file.status==="success") {
			// console.info(this.form.fileList)
			for (var i = 0; i < this.form.fileList.length; i++) {
				if(this.form.fileList[i].fileName === file.name){
					this.form.fileList.splice(i,1);
					break;
				}
			}
			for (var i = 0; i < this.fileList.length; i++) {
				if(this.fileList[i].fileName === file.name){
					this.fileList.splice(i,1);
					break;
				}
			}
			
			if(this.form.fileList.length<=0){
				this.form.fileInfo = null;
			}else{
				this.form.fileInfo = JSON.stringify(this.form.fileList);
			}
			this.divLength = ( 120 + (this.form.fileList.length - 1)*29.9375 ) +"px";
			this.$forceUpdate();
		}
	  },
	  handleError(){
		  this.form.fileUrl = null
		  this.$refs.upload.clearFiles();
		  this.$forceUpdate();
	  },
	  handlePreview(file) {
		console.log(file);
	  },
	  handleExceed(files, fileList) {
		this.$message({
				type: 'warning',
				message: "只能选择10个文件",
				customClass :'customClass',
				duration:3000,
		}); 
	  },
	  
	  add(){
		  if( ! this.check1 || ! this.check2 || ! this.check3){
			  this.required = true
			  return ;
		  }
		  this.required = false
		  
	  	this.$refs["form"].validate(valid => {
	  		if (valid) {
				console.info(this.form);
				this.loading = true
	  			axios.post('https://cms.ewway.com/ewway-api/feedback/infringement', this.form)
	  				.then(response => {
						this.loading = false
	  				  // 处理返回的数据
	  				  if(response.data.code===200){
	  					 this.$message({
	  					 							type: 'success',
	  					 							message: "Your request received!  We're working hard to reply ASAP. Thanks for your patience!",
	  					 							customClass :'customClass',
	  					 							duration:2000,
	  					 }); 
						 this.$refs['form'].resetFields();
						 this.$refs.upload.clearFiles();
						 this.divLength = ( 120 + (this.form.fileList.length - 1)*29.9375 ) +"px"
	  				  }else{
	  					  this.$message({
	  					  							type: 'error',
	  					  							message: "error",
	  					  							customClass :'customClass',
	  					  							duration:2000,
	  					  });
	  				  }
	  				  
	  				})
	  				.catch(error => {
	  				  console.error(error);
						this.loading = false
	  				  // 错误处理逻辑
	  				  this.$message({
	  							type: 'error',
	  							message: "error",
	  							customClass :'customClass',
	  							duration:2000,
	  				  });
	  				});
	  		}
	  			
	  	});
	  }
	  
	}
}
</script>
<style scoped>
	.df1{
		width:80%;
		margin-left:10%;
		text-align: left;
	}
	.labelSpan{
		position: absolute;
		top: -50px;
		font-size: 12px;
		color: #A5A3BE;
	}
	.divForm{
		padding-top: 20px;
		padding-right: 15px;
		padding-left: 8px;
		background-color: #F2F2F2;
		margin-top: 15px;
	}
	.divDFrom{
		font-size: 16px;;
		
	}
	.blueClass{
		height: 8px;
		width: 8px;
		background-color: #4A7FDB;
		float: left;
		margin: 5px;
		border-radius:4px
	}
	.customClass{
		font-size:12px;
	}
	.checkBoxClass{
		font-size: 12px;
	}
</style>